import * as React from 'react';
import {
    EditBase,
    Form,
    SaveButton,
    Toolbar,
    useEditContext,
} from 'react-admin';
import { Card, CardContent, Box } from '@mui/material';

import { RoleInputs } from './RoleInputs';
import { RoleAside } from './RoleAside';
import { Role } from '@/types';

export const RoleEdit = () => (
    <EditBase
        mutationMode="pessimistic"
        redirect="show"
        queryOptions={{ meta: { includes: 'permissions' } }}
    >
        <RoleEditContent />
    </EditBase>
);


const RoleEditContent = () => {
    const { isPending, record } = useEditContext<Role>();
    if (isPending || !record) return null;
    return (
        <Box mt={2} display="flex">
            <RoleAside link="show" />
            <Box flex="1">
                <Form>
                    <Card>
                        <CardContent>
                            <RoleInputs />
                        </CardContent>
                        <Toolbar>
                            <SaveButton />
                        </Toolbar>
                    </Card>
                </Form>
            </Box>
        </Box>
    );
};
